import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyItMatters from "@/components/site/WhyItMatters";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const Landing = () => {
  return (
    <div className="App" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyItMatters />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
